export default __webpack_public_path__ + "static/media/Horizontal.99ee8e52.jpeg";